import React from 'react'

// components
import {
  CRow
} from '@coreui/react-pro'
import AppTextColumnDetails from '../general-details/AppTextColumnDetails'

const AppDetails = ({
  settingDetails,
}) => {
  return (
    <>
      <CRow className='mb-4'>
        <AppTextColumnDetails
          colSize="3"
          className="mb-3"
          title="Max forever year"
          subtitle={settingDetails?.max_forever_year ? `${settingDetails?.max_forever_year} year` : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          className="mb-3"
          title="Company code"
          subtitle={settingDetails?.company_code ? `${settingDetails?.company_code}` : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          className="mb-3"
          title="Platform name"
          subtitle={settingDetails?.platform_name ? `${settingDetails?.platform_name}` : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          className="mb-3"
          title="Supported team"
          subtitle={settingDetails?.platform_name_supported_team ? `${settingDetails?.platform_name_supported_team}` : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          className="mb-3"
          title="Signature name"
          subtitle={settingDetails?.signature_name ? `${settingDetails?.signature_name}` : '-'}
        />
      </CRow>
    </>
  )
}

export default AppDetails
